import { SVGProps } from "react";

export default function NumberedListIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 13, width = 12, fill = "#333333", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_39693_83481)">
        <path
          d="M3.63281 2.60937H11.6484C11.8425 2.60937 11.9999 2.45197 11.9999 2.25781C11.9999 2.06366 11.8425 1.90625 11.6484 1.90625H3.63281C3.43866 1.90625 3.28125 2.06366 3.28125 2.25781C3.28125 2.45197 3.43866 2.60937 3.63281 2.60937Z"
          fill={fill}
        />
        <path
          d="M11.6484 6.14844H3.63281C3.43866 6.14844 3.28125 6.30584 3.28125 6.5C3.28125 6.69415 3.43866 6.85156 3.63281 6.85156H11.6484C11.8425 6.85156 11.9999 6.69415 11.9999 6.5C11.9999 6.30584 11.8425 6.14844 11.6484 6.14844Z"
          fill={fill}
        />
        <path
          d="M11.6484 10.3906H3.63281C3.43866 10.3906 3.28125 10.548 3.28125 10.7422C3.28125 10.9363 3.43866 11.0937 3.63281 11.0937H11.6484C11.8425 11.0937 11.9999 10.9363 11.9999 10.7422C11.9999 10.548 11.8425 10.3906 11.6484 10.3906Z"
          fill={fill}
        />
        <path
          d="M0.609375 1.20312H0.808875V3.42969C0.808875 3.62384 0.966281 3.78125 1.16044 3.78125C1.35459 3.78125 1.512 3.62384 1.512 3.42969V0.851562C1.512 0.657406 1.35459 0.5 1.16044 0.5H0.609375C0.415219 0.5 0.257812 0.657406 0.257812 0.851562C0.257812 1.04572 0.415219 1.20312 0.609375 1.20312Z"
          fill={fill}
        />
        <path
          d="M1.73632 7.43166C1.52897 7.43427 1.31065 7.43616 1.11575 7.43701C1.24838 7.25773 1.42057 7.02015 1.64023 6.70632C1.80664 6.46859 1.91539 6.2428 1.96353 6.03519C1.9662 6.02368 1.96828 6.01205 1.96978 6.00034L1.98228 5.90253C1.98418 5.88777 1.98511 5.87288 1.98511 5.85798C1.98511 5.30734 1.53715 4.85938 0.986535 4.85938C0.510426 4.85938 0.098324 5.19812 0.00665996 5.6648C-0.0307697 5.85533 0.0933553 6.04011 0.283879 6.07752C0.474426 6.1149 0.659183 5.99082 0.69659 5.8003C0.723637 5.66251 0.845582 5.5625 0.986511 5.5625C1.14336 5.5625 1.27205 5.68536 1.28143 5.83988L1.27484 5.89152C1.253 5.97535 1.19843 6.11129 1.06418 6.30315C0.664457 6.8743 0.42598 7.18653 0.297871 7.3543C0.136012 7.56622 0.0468553 7.68296 0.105543 7.87381C0.140512 7.98746 0.226316 8.07455 0.341043 8.11278C0.388621 8.12865 0.426754 8.14135 0.917605 8.14135C1.11246 8.14135 1.37869 8.13936 1.74518 8.13474C1.93932 8.1323 2.09473 7.97293 2.09232 7.77877C2.08983 7.58464 1.93018 7.42951 1.73632 7.43166Z"
          fill={fill}
        />
        <path
          d="M1.04297 9.21875C0.568031 9.21875 0.156984 9.55665 0.0655781 10.0222C0.0281484 10.2127 0.152273 10.3975 0.342797 10.4349C0.533344 10.4723 0.718102 10.3482 0.755508 10.1577C0.782344 10.021 0.903234 9.92188 1.04297 9.92188C1.20452 9.92188 1.33594 10.0533 1.33594 10.2148C1.33594 10.3764 1.20452 10.5078 1.04297 10.5078C0.848812 10.5078 0.691406 10.6652 0.691406 10.8594C0.691406 11.0535 0.848812 11.2109 1.04297 11.2109C1.20452 11.2109 1.33594 11.3424 1.33594 11.5039C1.33594 11.6655 1.20452 11.7969 1.04297 11.7969C0.897609 11.7969 0.772875 11.6887 0.752859 11.5453C0.750961 11.5317 0.75 11.5178 0.75 11.5039C0.75 11.3098 0.592594 11.1523 0.398437 11.1523C0.204281 11.1523 0.046875 11.3098 0.046875 11.5039C0.046875 11.5501 0.0501094 11.5967 0.0564609 11.6424C0.124688 12.1313 0.548813 12.5 1.04297 12.5C1.59223 12.5 2.03906 12.0532 2.03906 11.5039C2.03906 11.2583 1.94948 11.0332 1.80155 10.8594C1.94951 10.6855 2.03906 10.4605 2.03906 10.2148C2.03906 9.66561 1.5922 9.21875 1.04297 9.21875Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_39693_83481">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
